import { Divider, Flex, Navbar, NavLink } from "@mantine/core";
import { useCallback, useState } from "react";

import { useGenerateJwtToken } from "../../../api/hooks/auth/useGenerateJwtToken.ts";
import appConfig from "../../../config.ts";
import { useMutationNotificationWrapper } from "../../../hooks/useMutationNotificationWrapper.tsx";
import SvgCRM from "../../Icons/CRM.tsx";
import SvgLogout from "../../Icons/Logout.tsx";
import { useNavigationLinks } from "../hooks/useNavigationLinks.tsx";
import { useStyles } from "./Sidebar.styles.ts";

const Sidebar = () => {
  const [navBarIsOpen, setNavBarIsOpen] = useState(false);

  const { classes } = useStyles({ isOpen: navBarIsOpen });

  const [, generateJwtToken] = useMutationNotificationWrapper(
    useGenerateJwtToken(),
    { success: { show: false }, error: { show: false } }
  );

  const renderedLinks = useNavigationLinks({
    isOpen: navBarIsOpen,
  });

  const handleOpenCrm = useCallback(() => {
    generateJwtToken({}).then((data) => {
      const token = data.data?.generateJwtToken;
      if (!token) {
        return;
      }
      window.open(
        `${appConfig.crmUrl}?token=${token}`,
        "_blank",
        "noopener,noreferrer"
      );
    });
  }, [generateJwtToken]);

  return (
    <Navbar
      className={classes.wrapper}
      width={{ base: 84 }}
      hidden
      hiddenBreakpoint="52em"
      onMouseOver={() => setNavBarIsOpen(true)}
      onMouseOut={() => setNavBarIsOpen(false)}
    >
      <Flex
        direction="column"
        justify="space-between"
        className={classes.itemsWrapper}
      >
        <Flex direction="column">{renderedLinks}</Flex>
        <Flex direction="column" gap={12}>
          <Divider className={classes.divider} />
          <NavLink
            icon={<SvgCRM width={30} height={30} />}
            label="CRM"
            onClick={handleOpenCrm}
          />
          <Divider className={classes.divider} />
          <a
            className={classes.logoutWrapper}
            href={`${appConfig.apiUrl}/logout`}
          >
            <NavLink icon={<SvgLogout />} label="Log out" />
          </a>
        </Flex>
      </Flex>
    </Navbar>
  );
};

export default Sidebar;
